export enum ENavItemType {
  DIVIDER = 'divider',
  LINK = 'link',
  HEADER = 'header',
  BUTTON = 'button',
}
